import type { FaireProductEntity } from "../../entity_types/product";

export const p_r58mx9je95: FaireProductEntity = {
  token: "p_r58mx9je95",
  type: "product",
  name: "Women's Plush Leopard Print Crew Neck Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/2bbb9133ff658425d9c6c0860199c99a5465b442b05c90e5f4125bebcf732150.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcd529effd84860874fc33a3b693d875e8471834e3c74f55c277504278a6b3b2.jpeg",
    "https://cdn.faire.com/fastly/1b035be50b546736ef07fdea097d1e3a4636fcbf12a62a545df305c20638f653.png",
    "https://cdn.faire.com/fastly/b5ada2c8b8b0048db175247481276b16e457c66d8d008849efc8ad4f8405c5d9.jpeg",
    "https://cdn.faire.com/fastly/b8ba200e89bb97732f055e97207bb3f7eabbdb37f108e82f3cf93753f80c1333.jpeg",
    "https://cdn.faire.com/fastly/841722bc43d96fb66b95caf3e85b66ecb705fe1275cf5d07180725562ec386f3.jpeg",
    "https://cdn.faire.com/fastly/ddf49589e8f30fb7e37ec790f0f4d41ba0b326f1267c600ba5a24ae4e736874e.jpeg",
    "https://cdn.faire.com/fastly/1bf8eb26f89bdfb01efc41503f6657aa4bffe706663195d1ddbf44ebc9fe6271.png",
    "https://cdn.faire.com/fastly/f5c885c374ebe5f852d64650f0509af59c24f0f58476928d4fd2bd9160d49e66.jpeg",
    "https://cdn.faire.com/fastly/4875c0fc91c1f533ee75cd47eaa89cbdd44be7a9a7d2b77ff0a022ca54051929.jpeg",
    "https://cdn.faire.com/fastly/37e3c25e6c08dabc032f46d51cd539a4bd26139ae39dc7f2d81a0a592f576a60.jpeg",
    "https://cdn.faire.com/fastly/842cc5600feb6827211ee0afa8c4659574fa23251c3b1867cef22cfecec9b11f.png"
  ],
  priceDollars: 70,
  description: "Cozy Just Got Wild.\nMeet the Marshmallow Leopard Crew Neck Lounge Set—a bold new twist on our most iconic fabric. Made from Softies’ signature Marshmallow fabric (voted one of Oprah’s Favorite Things eight years running), this set delivers the same cloud-soft coziness and fuzzy warmth customers love—now with a playful leopard print that adds personality to your downtime. The crew neck top offers an easy, flattering fit, while the matching pant is relaxed yet polished enough to wear from couch to coffee run. It’s the perfect blend of comfort, style, and statement.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Plush, fuzzy texture that gets softer with every wash\n• Now in a bold, on-trend leopard print\n• Classic crew neck top with relaxed drape\n• Soft, open pant for elevated comfort\n• Ideal for gifting, lounging, or staying cozy in style\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞:\n• Fabric Content: 100% Polyester\n• Machine Washable\n• For best results: Turn inside out, wash cold, and line",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:01.984Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
